<template>
    <el-dialog
        ref="DialogMachine"
        v-model="visibled"
        :title="title"
        width="500"
        align-center
        draggable
        @closed="onClosed"
        @keyup.enter="doConfirm">
        <el-form
            ref="RuleFormRef"
            label-width="80"
            :model="data"
            :rules="rules"
            :hide-required-asterisk="true"
            :inline-message="true">
            <el-form-item label="机台" prop="mach_id">
                <el-select
                    v-model="data.mach_id"
                    autocomplete="off"
                    filterable
                    placeholder="必填项"
                    clearable
                    maxlength="32">
                    <el-option
                        v-for="item in machines"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="单号" prop="order_code">
                <el-input
                    v-model="data.order_code"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="产品" prop="product_name">
                <el-input
                    v-model="data.product_name"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="计划产量" prop="quantity_plan">
                <el-input
                    v-model="data.quantity_plan"
                    autocomplete="off"
                    placeholder="必填项"
                    clearable
                    maxlength="32">
                    <template #suffix>个</template>
                </el-input>
            </el-form-item>
            <el-form-item label="计划日期" prop="planned_date">
                <el-date-picker
                    v-model="data.planned_date"
                    type="date"
                    placeholder="必填项"
                    clearable
                    size="default" />
            </el-form-item>
            <el-form-item label="合格量" prop="quantity_qp">
                <el-input
                    v-model="data.quantity_qp"
                    type="int"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="次品量" prop="quantity_np">
                <el-input
                    v-model="data.quantity_np"
                    type="int"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item label="总产量" prop="quantity_total">
                <el-input
                    v-model="quantity_total"
                    disabled
                    type="int"
                    placeholder="必填项"
                    clearable
                    maxlength="32" />
            </el-form-item>
            <el-form-item v-if="!is_new" label="状态" prop="state">
                <el-select
                    v-model="data.state"
                    placeholder="必填项">
                    <el-option label="活跃" value="1" />
                    <el-option label="冻结" value="0" />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="foot_div">
            <el-row>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        @click="visibled = false">
                        取消
                    </el-button>
                </el-col>
                <el-col :span="4" />
                <el-col :span="6">
                    <el-button
                        class="btn_button"
                        :disabled="!validate"
                        type="primary"
                        @click="doConfirm">
                        保存
                    </el-button>
                </el-col>
                <el-col :span="4" />
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import {notify, dict, asleep} from '../../assets/js/utils.js';
import dayjs from 'dayjs';
export default {
    name: 'DialogMachine',
    components: {
    },
    props: {
    },
    data() {
        return {
            visibled: false,
            resolve: null,
            reject: null,
            title: null,
            list: [],
            data: {},
            machines: [],
            id: null,
        };
    },
    computed: {
        validate() {
            return true;
        },
        is_new() {
            console.log(`is new ${!this.id}`);
            return !this.id;
        },
        rules() {
            // 重复检测
            // const validate_duplicate = (rule, value, callback) => {
            //     const key = rule.field;
            //     if (this.list.some(x => x[key] === value && x.id !== this.data.id)) {
            //         callback(new Error(rule.message ?? `${rule.field} was duplicate.`));
            //     } else {
            //         callback();
            //     }
            // };
            // 重复检测
            const validate_duplicate_in_corporation = (rule, value, callback) => {
                const key = rule.field;
                if (this.original[key] === value) {
                    callback();
                } else if (this.list.some(
                    x => x[key] === value && x.id !== this.data.id && x.corp_id === this.data.corp_id,
                )) {
                    callback(new Error(rule.message ?? `${rule.field} was duplicate.`));
                } else {
                    callback();
                }
            };
            // 字段检测规则;
            const rules = {
                mach_id: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                ],
                order_code: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                    {
                        validator: validate_duplicate_in_corporation,
                        message: '名称',
                        trigger: ['change', 'blur'],
                    }],
                product_name: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                ],
                quantity_plan: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                ],
                planned_date: [
                    {required: true, message: '请输入', trigger: ['change', 'blur']},
                ],
            };

            const rule_fields = {
                true: ['mach_id', 'order_code', 'product_name', 'quantity_plan', 'planned_date'],
                false: ['mach_id', 'order_code', 'product_name', 'quantity_plan', 'planned_date'],
            };
            return rule_fields[this.is_new].reduce((rs, k) => {
                rs[k] = rules[k];
                return rs;
            }, {});
        },
        quantity_total() {
            return (parseInt(this.data.quantity_qp) || 0) + (parseInt(this.data.quantity_np) || 0);
        },
    },
    mounted() {
    },
    methods: {
        async show(options) {
            console.debug('options:', options);
            this.id = options.data.task?.id;
            this.options = options;
            this.visibled = true;
            this.title = options.title ?? (this.is_new ? '修改' : '添加');
            this.machines = options.machines.map(x => { return {id: `${x.id}`, name: x.name}; });
            this.list = options.list;
            Object.entries(this.data).forEach(([k, _]) => delete (this.data[k]));
            if (!this.is_new) {
                Object.entries({
                    'id': 'task.id',
                    'mach_id': 'task.mach_id',
                    'order_code': 'order_code',
                    'product_name': 'task.product_name',
                    'quantity_plan': 'task.quantity_plan',
                    'planned_date': 'task.planned_date',
                    'state': 'task.state',
                    'quantity_qp': 'task.quantity_qp',
                    'quantity_np': 'task.quantity_np',
                    'quantity_total': 'task.quantity_total',
                }).forEach(([tokey, fromkey]) => {
                    this.data[tokey] = fromkey.split('.').reduce((r, k) => {
                        return r[k];
                    }, options.data);
                    console.log(tokey, fromkey, this.data[tokey]);
                });
            }
            Object.entries(this.data).forEach(([k, v]) => {
                const datatype = typeof v;
                if (['boolean', 'number'].indexOf(datatype) >= 0) {
                    this.data[k] = `${v}`;
                    return;
                }
                if (datatype === null || datatype === undefined) {
                    this.data[k] = '';
                }
            });
            this.original = {...this.data};
            console.debug('Orgin:', this.original);
            // clear states
            (async () => {
                await asleep(100);
                this.$refs.RuleFormRef?.clearValidate();
            })();

            console.log('Show', this.data);
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        async doConfirm() {
            const form = this.$refs.RuleFormRef;
            try {
                await form.validate();
            } catch (e) {
                console.warn(e);
                notify('error', '填写错误！');
                return;
            }
            // 获取要提交的数据
            const fields = form.fields.map(x => x.prop);
            const empty = ['', null, undefined];
            const newdata = dict(Object.entries({
                ...this.data,
                ...{
                    planned_date: dayjs(this.data.planned_date).format('YYYY-MM-DD'),
                    // state: this.data.state_name === 'true' ? 1 : 0,
                },
            }).filter(([k, v]) => empty.indexOf(v) < 0 && fields.indexOf(k) >= 0));
            const olddata = this.original;
            console.log('OLD:', olddata);
            console.log('NEW:', newdata);
            const data = (() => {
                // 添加不需要过滤
                if (!olddata.id) return newdata;
                // 修改过滤未修改参数
                return dict(Object.entries(newdata).filter(([k, v]) => Array.isArray(v)
                    ? JSON.stringify(olddata[k].sort()) !== JSON.stringify(v.sort())
                    : olddata[k] !== v));
            })();
            if (Object.entries(data).length) {
                console.debug('submit data:', data);
                try {
                    const res = await this.axios.post(
                        `/api/tasks/${this.data.id || ''}`,
                        {...data, id: this.data.id},
                        {headers: {'Content-Type': 'application/json'}},
                    );
                    if (res.data.error) {
                        notify('error', `${res.data.error} ${res.data?.message}`);
                        return;
                    }
                } catch (e) {
                    notify(e);
                    console.error(e);
                    return;
                }
                this.resolve(data);
                this.reject = null;
                this.visibled = false;
                notify('success', '提交成功！', 999);
            } else {
                notify('warning', '无字段变化！');
            }
        },
        onClosed() {
            if (this.reject) {
                this.reject();
            }
        },
    },
};
</script>

<style>

</style>
